import { render } from "./DiagAten.vue?vue&type=template&id=170cabb8&scoped=true"
import script from "./DiagAten.vue?vue&type=script&lang=js"
export * from "./DiagAten.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada02.css?vue&type=style&index=0&id=170cabb8&scoped=true&lang=css"
import "@/assets/css/tabla_estilizada.css?vue&type=style&index=1&id=170cabb8&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=2&id=170cabb8&scoped=true&lang=css"
import "./DiagAten.vue?vue&type=style&index=3&id=170cabb8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170cabb8"]])

export default __exports__